(function($) {
	let page = "";
	function find_page_number(element) {
		element.find("span").remove();
		return parseInt(element.html());
	}
	/* eslint-disable */
	function ajax_pagination_page() {
		let data = {
			action: "ajax_pagination",
			formdata: filterForm.serialize(),
			page: page,
		};
		$.post(ajaxpagination, data, function(response) {
			let mainAjax = $(".woocommerce-products__main");
			$(".woocommerce-products__footer .pagination").remove();
			mainAjax.fadeOut(100, function() {
				mainAjax.html(response);
				mainAjax.fadeIn();
			});
		});
	}
	/* eslint-enable */
	let filterForm = $("[data-filter-form]");
	let productQuantity = $("[data-view-all]");

	$(document).on("click", ".view-all", function(e) {
		e.preventDefault();
		productQuantity.val(-1);
		page = "";
		ajax_pagination_page();
		let productCount = productQuantity.attr("main-value");
		productQuantity.val(productCount);
	});

	filterForm.on("change", e => {
		e.preventDefault();
		page = "";
		ajax_pagination_page();
	});

	$(document).on(
		"click",
		".woocommerce-products__footer .nav-links a:not(.next):not(.prev)",
		function(event) {
			event.preventDefault();
			page = find_page_number($(this).clone());
			ajax_pagination_page();
		}
	);

	$(document).on(
		"click",
		".woocommerce-products__footer .nav-links a.next",
		function(event) {
			event.preventDefault();
			page = find_page_number($(".current").clone());
			page += 1;
			ajax_pagination_page();
		}
	);

	$(document).on(
		"click",
		".woocommerce-products__footer .nav-links a.prev",
		function(event) {
			event.preventDefault();
			page = find_page_number($(".current").clone());
			page -= 1;
			ajax_pagination_page();
		}
	);
})(jQuery);



// WEBPACK FOOTER //
// ./scripts/ajax-pagination.js